// InvoiceCard.js
import styles from "./ResultCard.module.css";

const formatLabel = (key) =>
  key
    .replaceAll("_", " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

const getValueFor = (value) => {
  if (value == null) return "---";
  if (typeof value === "object") return <pre>{JSON.stringify(value, null, 2)}</pre>;
  return <pre>{value.toString()}</pre>;
};

const renderDictSection = (title, obj) => {
  if (!obj || typeof obj !== "object") return null;

  return (
    <div className={styles["section-card"]}>
      <h3>{title}</h3>

      <div className={styles["fields-section"]}>
        {Object.entries(obj).map(([key, value]) => (
          <div className={styles["fields-row"]} key={key}>
            <div className={styles["fields-name"]}>{formatLabel(key)}:</div>
            <div className={styles["fields-value"]}>{getValueFor(value)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const InvoiceCard = ({ data }) => {
  // data is expected to be the object that contains invoice/shipping_document/due_di
  // e.g. <InvoiceCard data={response.invoice_extraction} />
  // or if it's wrapped: <InvoiceCard data={response.someKey} />

  if (!data || (typeof data === "object" && Object.keys(data).length === 0)) {
    return (
      <div className={styles["container"]}>
        <div className={styles["section-card"]}>
          <div>Nenhum resultado pode ser extraído para este documento</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles["container"]}>
        <div className={styles["section-card"]}>
            <div className={styles["fields-section"]}>
                <div className={styles["fields-row"]}>
                    <div className={styles["fields-name"]}>outcome:</div>
                    <div className={styles["fields-value"]}>{data.outcome}</div>
                </div>
                <div className={styles["fields-row"]}>
                    <div className={styles["fields-name"]}>modality:</div>
                    <div className={styles["fields-value"]}>{data.modality}</div>
                </div>
            </div>
        </div>
        {renderDictSection("Invoice", data.fields?.invoice)}
        {renderDictSection("Shipping Document", data.fields?.shipping_document)}
        {renderDictSection("Due DI", data.fields?.due_di)}
    </div>
  );
};

export default InvoiceCard;
